<template>
  <div class="Cristal">
    <canvas id="canvas" ref="canvas" class="canvas" :class="{ show: ready }"/>  
  </div>
</template>

<script>

import 'babylonjs-materials'
import 'babylonjs-loaders'
import gsap from "gsap"
import 'gsap-babylon-plugin'

import { Engine, Scene, Color3, FreeCamera, Vector3, HemisphericLight, Mesh, SceneLoader, DirectionalLight, PointLight } from 'babylonjs'


export default {
  name: 'Cristal',
  props: ['indice'],
  components: {},
  data: ()=>({
    ready: false
  }),
  beforeDestroy() {
    if(this.$scene)
      this.$scene.dispose()
  },

  mounted: async function() {

    const canvas = this.$refs.canvas
    const engine = new Engine(canvas, true, { preserveDrawingBuffer: true, stencil: true })
    const scene = new Scene(engine)
          scene.createDefaultCameraOrLight(false, true, true)
          // scene.clearColor = Color3.FromHexString('#ffffff') 
          scene.clearColor = new BABYLON.Color4(0, 0, 0, 0)
    const camera = scene.activeCamera

    engine.runRenderLoop(() => { scene.render() })
    engine.resize()

    const cristal = await SceneLoader.LoadAssetContainerAsync("/static/", "crystal.glb", scene)
    const CR1 = cristal.instantiateModelsToScene()
    let mesh = new Mesh('mesh', scene).addChild(CR1.rootNodes[0])

    gsap.set(mesh.scaling, { x: .6, y: .6, z: .6 })
    // gsap.set(mesh.position, { y: .1 })
    gsap.to(mesh.rotation, { 
      y: (Math.PI/180)*360, 
      duration: 10, repeat:-1, ease: 'none' })

    this.ready = true
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Cristal
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden
  opacity .8
 
  &.responsive 
    width 100%
    height 100%

  canvas
    width 100%
    height 100%
    opacity 0
    transition opacity .5s
    transition-delay 1

    &.show 
      opacity 1

</style>























